import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { formatterDate } from "../../../utils"
import { ReinforcedControlMeasureDTO } from "./dataService/dto"
import { GetAllReinforcedControlMeasures, setReinforcedIdToUpdate, setReinforcedUpdateActiveFrom, setReinforcedUpdateClosingDate, setReinforcedUpdateClosingMotivationNote, setReinforcedUpdateClosingNote, setReinforcedUpdateClosingProtocolId, setReinforcedUpdateDepartureProtocolIds, setReinforcedUpdateEntryProtocolIds, setReinforcedUpdateMotivationNote, setReinforcedUpdateMotivationType, setReinforcedUpdateNote } from "./slice"
import { handleProtocolListing } from "./utils"

export function ReinforcedList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const reinforcedControlMeasureState = useAppSelector(state => state.reinforcedControlMeasure)

    useEffect(() => {
        dispatch(GetAllReinforcedControlMeasures(reinforcedControlMeasureState.getAllReinforcedControlMeasureFilters))
    }, [])

    const onEditHandle = (rcm: ReinforcedControlMeasureDTO) => {
        dispatch(setReinforcedUpdateActiveFrom(rcm.activeFrom))
        dispatch(setReinforcedUpdateMotivationType(rcm.motivationType))
        dispatch(setReinforcedUpdateMotivationNote(rcm.motivationNote))
        dispatch(setReinforcedUpdateEntryProtocolIds(rcm.entryProtocolsInfo ? rcm.entryProtocolsInfo.map(ep => ep.protocolId) : undefined))
        dispatch(setReinforcedUpdateDepartureProtocolIds(rcm.departureProtocolsInfo ? rcm.departureProtocolsInfo.map(dp => dp.protocolId) : undefined))
        dispatch(setReinforcedUpdateNote(rcm.note))
        dispatch(setReinforcedUpdateClosingDate(rcm.closingDate))
        dispatch(setReinforcedUpdateClosingMotivationNote(rcm.closingMotivationNote))
        dispatch(setReinforcedUpdateClosingProtocolId(rcm.closingProtocolId !== null ? rcm.closingProtocolId : undefined))
        dispatch(setReinforcedUpdateClosingNote(rcm.closingNote))
        dispatch(setReinforcedIdToUpdate(rcm.id))

        navigate('/editReinforcedControlMeasure')
    }

    return (
        <div className="w-full p-4">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table id="users-table" className="w-full border-collapse text-sm">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tl-xl w-[56px]"></th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data attivazione</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Documenti</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data chiusura</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Motivazione chiusura</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Comunicazione chiusura</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(reinforcedControlMeasureState.getAllReinforcedControlMeasureResponse?.data || []).length === 0 ? (
                            <tr>
                                <td colSpan={8} className="px-3 py-4 text-center text-neutral-500 bg-white">
                                    Nessuna misura trovata
                                </td>
                            </tr>
                        ) : (
                            reinforcedControlMeasureState.getAllReinforcedControlMeasureResponse?.data.map((rcm, rowIndex) => (
                                <tr
                                    key={rcm.id}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${rowIndex % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-center">
                                        <button
                                            className="inline-flex items-center justify-center p-1.5 rounded-full border border-orange-200 bg-orange-50 hover:bg-orange-100 transition-colors"
                                            onClick={() => onEditHandle(rcm)}
                                        >
                                            <EditIcon color="orange" size={18} />
                                        </button>
                                    </td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{rcm.customerCompanyName || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{rcm.customerCountryRegion || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(rcm.activeFrom)}</td>
                                    <td className="px-3 py-2 text-neutral-700">{handleProtocolListing(rcm.entryProtocolsInfo, rcm.departureProtocolsInfo)}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(rcm.closingDate)}</td>
                                    <td className="px-3 py-2 text-neutral-700">{rcm.closingMotivationNote || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700">{rcm.closingProtocolInfo || '-'}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}